<script setup lang="ts">
import type { NuxtError } from '#app'

defineProps<{
  error: NuxtError
}>()

const handleError = () => clearError({ redirect: '/' })
</script>

<template>
  <v-app>
    <div class="d-flex flex-column align-center justify-center" style="min-height: 100vh">
      <h1 class="text-primary text-h1 font-weight-regular mb-4">
        {{ error.statusCode }}
      </h1>
      <p class="text-h5 font-weight-regular mb-8">
        {{ error.statusCode === 404 ? 'Seite nicht gefunden' : 'Ein Fehler ist aufgetreten' }}
      </p>
      <v-btn color="primary" variant="flat" @click="handleError"> Zurück zur Startseite </v-btn>
    </div>
  </v-app>
</template>
